import {SERVICES} from '@/const/services';

export const IMAGES = {
  gift: '67d1b5c342d43814875d3272e36ca67ce81fbcad7692200b8f1a7c66442e8fdc.gif',
  gift_static: 'a821e4b169b122adefb6b0b5854542f8a08394e1d02a99eea5cf43cc831bc4c6.png',
  GOOGLE_ICON: '4a8758006edf93421d2095aab135e3f2a34f0bbacd2ceb84308291d60cd7176e.png',
};
const PREFIX_RECEIVE2 = `${SERVICES.STATIC_URL}/pubimg/`;
const PREFIX_RECEIVE = `${SERVICES.IMG_URL}/v1/`;

Object.keys(IMAGES).forEach((key) => (IMAGES[key] = [PREFIX_RECEIVE2, IMAGES[key]].join('')));

export const IMAGES_NEW = {
  GOOGLE_ICON: 'b5bf8687-52d6-4d86-acf1-94b173b5738b/group-66.svg',
  TWITTER_ICON: '793d868a-74fe-4f61-aff1-5dc4389da5a3/loe-0-dx-9-pg-8-p59-2.svg',
  TWITTER_ICON_BLACK: '37cbdfe4-17d8-4e21-b463-8df145b55d14/loe-0-dx-9-pg-8-p59-2-1.svg',
  ACCESS_ICON: 'bd3d2ac7-5ee3-40ec-b374-8edad69657c2/wallet-connect-logo-mark-2.svg',
};

Object.keys(IMAGES_NEW).forEach((key) => (IMAGES_NEW[key] = [PREFIX_RECEIVE, IMAGES_NEW[key]].join('')));
